import { Injectable } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { AbstractStorageService } from '@df/browser/storage/abstract-storage.service';

@Injectable({
    providedIn: 'root'
})
export class StateStorageService extends AbstractStorageService {
    /**
     * Data storage object
     */
    private storage: { [key: number]: any } = {};

    /**
     * Current navigation id
     */
    private navigationId = 1;

    /**
     * Last successful navigation id
     */
    private lastSuccessfulId = 1;

    /**
     * Class constructor
     */
    constructor(private router: Router) {
        super();
        this.router.events.subscribe(e => this.onRouterChange(e));
    }

    /**
     * Router events listener
     */
    private onRouterChange(event): void {
        if (
            !(
                event instanceof NavigationStart ||
                event instanceof NavigationEnd ||
                event instanceof NavigationError ||
                event instanceof NavigationCancel
            )
        ) {
            return;
        }

        // copy data to new state
        if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
            this.navigationId = event.id;
        } else if (event instanceof NavigationStart) {
            if (event.restoredState) {
                this.storage[event.id] = this.storage[event.restoredState.navigationId];
            } else {
                if (event.navigationTrigger === 'popstate') {
                    this.storage[event.id] = this.storage[this.lastSuccessfulId];
                    this.lastSuccessfulId = this.storage[event.id]?.lastSuccessfulId || 1;
                } else {
                    this.lastSuccessfulId = this.navigationId;
                    this.storage[event.id] = {
                        ...this.storage[event.id],
                        lastSuccessfulId: this.lastSuccessfulId
                    };
                }
            }
        }
    }

    ///////////////////////////
    ///
    /// Data manipulation
    ///
    ///////////////////////////

    /**
     * Gets store data object
     */
    protected getData(): any {
        return this.storage[this.navigationId] || {};
    }

    /**
     * Sets data in storage
     */
    protected setData(data: any) {
        this.storage[this.navigationId] = data;
    }

    getNavigationId() {
        return this.navigationId;
    }
}
